import * as React from 'react';
import { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Plant from 'benchmarking-domain/plant';
import { PlantsTable } from 'components/client/plants/plants-table';
import useApi from 'hooks/use-api';

import { useOrganisation } from '../../../hooks/use-organisation';

export default function Plants(): React.JSX.Element {
  const { subscribePlants } = useApi();
  const { organisationId } = useOrganisation();

  const [plants, setPlants] = useState<Plant[]>([]);

  useEffect(() => {
    if (!organisationId) {
      return;
    }

    const unsubscribe = subscribePlants(organisationId, (fetchedPlants) => {
      setPlants(fetchedPlants?.sort((one, two) => (one.name < two.name ? -1 : 1)));
    });

    return () => {
      unsubscribe();
    };
  }, [subscribePlants, organisationId]);

  return (
    <Stack spacing={3}>
      <Stack direction="row" spacing={3}>
        <Stack spacing={1} sx={{ flex: '1 1 auto' }}>
          <Typography variant="h4">Plants</Typography>
        </Stack>
      </Stack>

      <PlantsTable rows={plants} />
    </Stack>
  );
}
